const WorkExperience = [
  {
    id: 1,
    title: "Software Engineer - Intern",
    company: "Fleet-Labs Ghana",
    yearsActive: "January 2024 - Present",
    information: [
      "Write modern, performant, maintainable code for a diverse array of internal projects",
      "Communicate with multi-disciplinary teams of engineers, team leads, and QA Engineers on a daily basis",
    ],
  },
  {
    id: 2,
    title: "Back-End Engineer",
    company: "Strategic Structures Inc.",
    yearsActive: "August 2024 - Present",
    information: [
      "Improved and optimized the company's website for a seamless customer experience",
      "Created, communicated, and managed project plans & project timelines",
      "Worked to continually meet the expectation of our clients",
    ],
  },
  {
    id: 3,
    title: "Junior Software Developer",
    company: "Slim Tech",
    yearsActive: "May 2023 - Present",
    information: [
      "Planned, developed, tested, deployed, and maintained desktop applications and mobile applications",
      "Worked well independently and on a team to solve problems.",
    ],
  },
  {
    id: 4,
    title: "Software Engineer Intern",
    company: "The TechTalk Academy",
    yearsActive: "September 2022 - January 2023",
    information: [
      "Served as a dedicated and supportive Intern in a fast-paced environment",
      "Worked to solve complex problems using the latest in Mobile and Web Technologies.",
    ],
  },
  {
    id: 5,
    title: "IT Support Assistant",
    company: "Tech College",
    yearsActive: "February 2017 - May 2019",
    information: [
      "Worked to support the senior support staff with day-to-day tasks.",
      "Assisted with the evaluation and troubleshooting of hardware and software issues.",
      "Maintaining computer Inventory & surplus equipment.",
    ],
  },
  {
    id: 6,
    title: "Student Ambassador",
    company: "University of Cape Coast",
    yearsActive: "December 2023 - Present",
    information: [
      "Monitored registration for all prospective student",
      "Assisted parents and prospective student with necessary registration details",
    ],
  },
];

export default WorkExperience;
